import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import uniqueId from 'lodash/uniqueId';

import cn from '../../lib/class-name';

/**
 * A toggle button which can be active or not.
 *
 * A ref created with "React.createRef()" can be passed to the component. It makes the inputs "focus()" function accessible.
 */
class ToggleField extends React.Component {
  inputRef = React.createRef();

  inputId = uniqueId('toggle-');

  focus = () => {
    if (this.inputRef.current) {
      this.inputRef.current.focus();
    }
  };

  render() {
    const {
      checked,
      classNames,
      disabled = false,
      id = this.inputId,
      name,
      onBlur = noop,
      onChange = noop,
      value,
    } = this.props;

    return (
      <label
        htmlFor={id}
        role="checkbox"
        className={cn(
          'hpl2-ToggleField',
          {
            default: !checked, // Used for explicitness in CSS only
            checked,
          },
          classNames
        )}
        aria-checked={checked}
        aria-disabled={disabled}
      >
        <input
          ref={this.inputRef}
          className="hpl2-ToggleField__input"
          type="checkbox"
          id={id}
          name={name}
          value={value}
          checked={checked}
          disabled={disabled}
          onChange={(event) => onChange(!checked, event)}
          onBlur={onBlur}
        />
      </label>
    );
  }
}

ToggleField.displayName = 'ToggleField';
ToggleField.propTypes = {
  /** Optional array of CSS utility classes. */
  classNames: PropTypes.arrayOf(PropTypes.string),
  /** If no id is provided an id is generated automatically. */
  id: PropTypes.string,
  /** Input field name */
  name: PropTypes.string,
  /** Input field value */
  value: PropTypes.string,
  /** Element checked state */
  checked: PropTypes.bool,
  /** Modifier for disabled state */
  disabled: PropTypes.bool,
  /** Call signature: (value, event) => {} */
  onChange: PropTypes.func,
  /** Call signature: (event) => {} */
  onBlur: PropTypes.func,
};

export default ToggleField;
